import { SelectedProvider, convertPublicProfileToSelectedProviderType } from '@uplift/pages';
import { Button, ClickToCopy, Modal, NavigationBackButton, ProviderDialogNavigation, ScrollableView } from '@uplift/ui-v2';
import { useProfileContext } from '../profile.context';
import { useProviderPublicProfiles, useStates } from '@uplift/queries';
import { Box } from '@mui/material';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { InsertLinkOutlined } from '@mui/icons-material';
import { getProviderPublicProfileDomain } from '@uplift/utils';

export type PreviewProfileModalProps = {
  open: boolean;
  onClose: () => void;
};

export const PreviewProfileModal: React.VFC<PreviewProfileModalProps> = props => {
  const { states } = useStates();
  const { profile } = useProfileContext();
  const isMobile = useIsMobile();
  const l10n = useL10n();
  const provider = convertPublicProfileToSelectedProviderType(profile, states);
  const publicProfileDomain = getProviderPublicProfileDomain();
  const { data: providerPublicProfiles = [] } = useProviderPublicProfiles(provider.id);
  const providerPublicProfile = providerPublicProfiles[0];

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      fullScreen
    >
      <ProviderDialogNavigation
        position="sticky"
        title="Profile Preview"
        leftActions={
          <NavigationBackButton onClick={props.onClose}>{isMobile ? `${l10n.navigation.back}` : `${l10n.navigation.backToEdit}`}</NavigationBackButton>
        }
        rightActions={providerPublicProfile ? (
          <ClickToCopy text={`${publicProfileDomain}${providerPublicProfile.url}`} arrow copyMessage="Copy Link">
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              endIcon={<InsertLinkOutlined />}
            >
              Copy Public Profile Link
            </Button>
          </ClickToCopy>
        ) : null}
      />
      <ScrollableView>
        <Box>
          <SelectedProvider
            // use first license state for preview
            stateId={profile.licenses?.[0]?.stateId}
            selectedProvider={provider}
            onScheduleSession={() => {
              return;
            }}
            isPublicProfile
            isPreview
            isScrollableView
          />
        </Box>
      </ScrollableView>
    </Modal>
  );
};
